import { createFileRoute } from '@tanstack/react-router';

import { trpc } from '../../../../../services/trpc';
import { ClientSection } from './-client-section';

export const Route = createFileRoute('/app/projets/$slug/client/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: project } = trpc.projects.get.useQuery({ slug: params.slug });

  if (!project) {
    return null;
  }

  return <ClientSection project={project} />;
}
